import { render, staticRenderFns } from "./header-only.vue?vue&type=template&id=ecf383d2"
import script from "./header-only.vue?vue&type=script&lang=js"
export * from "./header-only.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/members-area.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports